// extracted by mini-css-extract-plugin
export default {"root":"ExpertKnowledgeDetails_root__VEuLH","filter":"ExpertKnowledgeDetails_filter__gOyzA"};